export const CampaignStatus = Object.freeze({"pending":"pending", "active":"active", "completed":"completed"})
export const MediaType = Object.freeze({"youtube":"YouTube", "facebook":"Facebook", "instagram":"Instagram"})

import * as Moment from 'moment-timezone'

export class Campaign {
  public id: number
  public title: string
  public status: string
  public description: string
  public deadline: any
  public startDate: any
  public endDate: any
  public logo: string
  public brief: string
  public images: any[]
  public users: any[]
  public admins: any[]
  public client: any
  public mediaType: string
  public tags: any[]
  public maxUsers: number
  public updated: boolean
  public totalPrice: number
  public participating: number

  constructor(campaign:any = {}) {
    this.id = campaign.id || null
    this.status = campaign.status || CampaignStatus.pending
    this.deadline =  campaign.deadline? Moment.tz(campaign.deadline, process.env.REACT_APP_TIMEZONE || "") : Moment().tz(process.env.REACT_APP_TIMEZONE || "")
    this.startDate =  campaign.startDate? Moment.tz(campaign.startDate, process.env.REACT_APP_TIMEZONE || "") : Moment().tz(process.env.REACT_APP_TIMEZONE || "")
    this.endDate =  campaign.endDate? Moment.tz(campaign.endDate, process.env.REACT_APP_TIMEZONE || "") : Moment().tz(process.env.REACT_APP_TIMEZONE || "")
    this.title = campaign.title || ""
    this.description = campaign.description || ""
    this.logo = campaign.logo || ""
    this.brief = campaign.brief || ""
    this.admins = campaign.admins? campaign.admins.map((admin:any)=>{return {new:false,id: admin.id, label:admin.name, value: admin.id}}) : []
    this.users = []
    if(campaign.users) {
      this.users = campaign.users.map((user: any) => {
        user.mediaToApprove = 0
        user.newMedia = 0
        if(user.media) {
          user.media.map((media: any) => {
            if(media.status == "predeclined") {
              user.mediaToApprove++
            } else if(media.status == "reviewing") {
              user.newMedia++
            }
          })
        }

        return user
      })
    }
    this.tags = campaign.tags? campaign.tags.map((tag:any)=>{return {id: tag.id, label:tag.tag, value: tag.tag}}) : []
    this.client = campaign.client || null
    this.mediaType = campaign.mediaType || "facebook"
    this.images = campaign.images || []
    this.maxUsers = campaign.maxUsers || 0
    this.updated = true
    this.totalPrice = campaign.totalPrice || 0
    this.participating = campaign.participating || 0
  }
}



// WEBPACK FOOTER //
// ./src/_models/Campaign.tsx